import { NotificationBar } from '@percent/cause-dashboard/common/components'
import {
  useIsDesktopLayout,
  useNotificationBar,
  useSitewideMessage,
  useSocialImpactOrg
} from '@percent/cause-dashboard/common/hooks'
import { config } from '@percent/cause-dashboard/config'
import { useCallback, useEffect, useState } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { RoutePath } from '@percent/cause-dashboard/app/routes/Routes'
import { SideMenu } from '../sideMenu/SideMenu'
import { TopBar } from '../topbar/TopBar'
import styles from './DashboardLayout.module.scss'

interface DashboardLayoutProps {
  children: React.ReactNode
}

export const DashboardLayout = ({ children }: DashboardLayoutProps) => {
  const notification = useNotificationBar()
  const { shouldShowSitewideMessage } = useSitewideMessage()
  const shiftDownToAccomodateNotification = notification.isOpened || shouldShowSitewideMessage ? 48 : 0
  const minHeightConditionalOnNotification =
    notification.isOpened || shouldShowSitewideMessage ? 'calc(100vh - 48px)' : '100vh'

  const location = useLocation()
  const { isSocialImpactOrg, isSocialImpactRoute } = useSocialImpactOrg()

  const isDesktop = useIsDesktopLayout()
  const isMobileLayout = isDesktop === false
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)

  const openMobileMenu = useCallback(() => setMobileMenuOpen(true), [])
  const closeMobileMenu = useCallback(() => setMobileMenuOpen(false), [])

  useEffect(() => {
    if (isDesktop) {
      setMobileMenuOpen(false)
    }
  }, [isDesktop])

  if (isSocialImpactOrg && !isSocialImpactRoute(location.pathname)) {
    return <Navigate to={RoutePath.PROFILE} replace />
  }

  return (
    <div className={styles.container}>
      {<NotificationBar config={config} />}
      <div style={{ minHeight: minHeightConditionalOnNotification }}>
        <SideMenu isMobileLayout={isMobileLayout} mobileMenuOpen={mobileMenuOpen} onCloseMobileMenu={closeMobileMenu} />

        <div className={styles.pageWrapper} style={{ marginTop: shiftDownToAccomodateNotification }}>
          <TopBar mobileMenuOpen={mobileMenuOpen} onOpenMobileMenu={openMobileMenu} />
          <div className={styles.pageContent}>{children}</div>
        </div>
      </div>
    </div>
  )
}
